import React from 'react';
import { CalendarIcon as HeroCalendarIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type CalendarIconProps = Omit<IconProps, 'children'>;

export const CalendarIcon: React.FC<CalendarIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroCalendarIcon />
        </Icon>
    );
};
